import { render, staticRenderFns } from "./EditableLabel.vue?vue&type=template&id=442b3ef4&scoped=true"
import script from "./EditableLabel.vue?vue&type=script&lang=js"
export * from "./EditableLabel.vue?vue&type=script&lang=js"
import style0 from "./EditableLabel.vue?vue&type=style&index=0&id=442b3ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b3ef4",
  null
  
)

export default component.exports